import { Z_INDEX_POPOVER as r } from "./index.es191.js";
function s({
  tooltip: i,
  lockedTooltip: t,
  zIndexBase: o = r + 1
}) {
  if (!i && !t)
    return;
  if (typeof i == "string")
    return {
      title: i,
      tooltipPositioning: {
        zIndex: o
      },
      lockedTooltip: t
    };
  const n = i || {};
  return {
    ...n,
    tooltipPositioning: {
      zIndex: o,
      ...n.tooltipPositioning
    },
    lockedTooltip: t
  };
}
export {
  s as mergeTooltipPropsForSmartTooltip
};
//# sourceMappingURL=index.es5534.js.map
